import styled from 'styled-components';

import Divider from '@/components/atom/Divider';
import DoctorProfile from '@/components/templates/doctor/detail/components/DoctorSummary/DoctorProfile';
import DoctorReviewAndDepartments from '@/components/templates/doctor/detail/components/DoctorSummary/DoctorReviewAndDepartments';
import { LoadedDoctorDetailViewModel } from '@/components/templates/doctor/detail/useDoctorDetailViewModel';
import { DoctorReviewsViewModel } from '@/components/templates/doctor/detail/useDoctorReviewsViewModel';

import DoctorDiagnosisSchedules from './DoctorDiagnosisSchedules';

interface Props {
  doctorDetailViewModel: LoadedDoctorDetailViewModel;
  doctorReviewsViewModel: DoctorReviewsViewModel;
}

const DoctorSummary = ({ doctorDetailViewModel, doctorReviewsViewModel }: Props) => {
  return (
    <Wrapper>
      <DoctorProfile viewModel={doctorDetailViewModel} />
      <ReviewAndDepartments>
        <DoctorReviewAndDepartments
          doctorDetailViewModel={doctorDetailViewModel}
          doctorReviewsViewModel={doctorReviewsViewModel}
        />
      </ReviewAndDepartments>
      {doctorDetailViewModel.isBookableFromBookingAvailability(
        doctorDetailViewModel.doctorDetail?.bookingInfo?.bookingAvailability
      ) && (
        <>
          <StyledDivider />
          {doctorDetailViewModel.doctorDetail && (
            <DoctorDiagnosisSchedules
              doctorDetail={doctorDetailViewModel.doctorDetail}
              onClickDiagnosisSlotInSummary={doctorDetailViewModel.onClickDiagnosisSlotInSummary}
              onClickDiagnosisSlotSelectBox={doctorDetailViewModel.onClickDiagnosisSlotSelectBox}
              isOpenedDiagnosisSlotBottomSheet={doctorDetailViewModel.isOpenedDiagnosisSlotBottomSheet}
              onChangeDiagnosisSlotBottomSheet={doctorDetailViewModel.onChangeDiagnosisSlotBottomSheet}
              selectedDiagnosisSlot={doctorDetailViewModel.selectedDiagnosisSlot}
              onChangeDiagnosisSlot={doctorDetailViewModel.onChangeDiagnosisSlot}
              requestTreatmentWithSlot={doctorDetailViewModel.requestTreatmentWithSlot}
            />
          )}
        </>
      )}
    </Wrapper>
  );
};

export default DoctorSummary;

const Wrapper = styled.div`
  display: flex;
  padding-bottom: 28px;
  flex-direction: column;
  gap: 12px;
  align-self: stretch;
`;

const StyledDivider = styled(Divider)`
  display: flex;
  width: calc(100% - 48px);
  align-self: center;
  margin: 12px 0;
`;

const ReviewAndDepartments = styled.div`
  padding: 0 24px;
`;
